import {useNavigate} from "react-router-dom";
import {useContext, useState} from "react";
import {
    Box,
    Container,
    Fab,
    Tabs,
    Tab, useTheme, useMediaQuery
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ProductList from "../components/ProductList.tsx";
import ProductContext from "../contexts/ProductContext.tsx";
import AuthContext from "../contexts/AuthContext.tsx";
import {useTranslation} from "react-i18next";
import ReviewList from "../components/ReviewList.tsx";

const HomePage = () => {
    const {t} = useTranslation();
    const {isAdmin} = useContext(AuthContext);
    const {products, loadingProducts} = useContext(ProductContext);
    const navigate = useNavigate();
    const [tabIndex, setTabIndex] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const handleCreateProduct = () => {
        navigate("/create-product");
    };

    const handleTabChange = (_event: any, newIndex: any) => {
        setTabIndex(newIndex);
    };

    const backgroundImage = isMobile
        ? '/Background.jpg'
        : '/BackgroundDesktop.jpg';


    return (
        <Box>
            <Box
                component="img"
                src={backgroundImage}
                alt="Background"
                sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain', // keep full image visible
                }}
            />
            <Container>
                <Tabs value={tabIndex} onChange={handleTabChange} centered>
                    <Tab label={t("PRODUCTS")} sx={{textTransform: "none"}}/>
                    <Tab label={t("REVIEWS")} sx={{textTransform: "none"}}/>
                </Tabs>

                {!loadingProducts && tabIndex === 0 && <ProductList products={products}/>}
                {tabIndex === 1 && <ReviewList/>}

                {isAdmin && tabIndex === 0 && (
                    <Box
                        sx={{
                            position: "fixed",
                            bottom: 16,
                            right: 16,
                        }}
                    >
                        <Fab color="primary" aria-label="add" onClick={handleCreateProduct}>
                            <AddIcon/>
                        </Fab>
                    </Box>
                )}
            </Container>
        </Box>
    );
};

export default HomePage;
